import React from 'react';
import { format, parseISO } from 'date-fns';

export const Timestamp = ({ data }: { data: string }) => {
  const convertTimestamp = (timestamp: string, convertFormat: string): string => {
    return format(parseISO(timestamp), convertFormat);
  };

  return (
    <>
      <span>{convertTimestamp(data, 'yyyy-MM-dd')} </span>
      <span style={{ color: '#4A545D' }}>{convertTimestamp(data, 'HH:mm')}</span>
    </>
  );
};
